import AddCircleIcon from '@material-ui/icons/AddCircle'
import { Fragment } from 'react'

import { Card } from '../../../components/Base/Card'
import { Divider } from '../../../components/Base/Divider'
import { FlexBox } from '../../../components/Base/FlexBox'
import { Grid } from '../../../components/Base/Grid'
import { Button } from '../../../components/Button/Button'
import { CopyToClipBoardIcon } from '../../../components/CopyToClipBoard/CopyToClipBoard'
import { InlineSpinner } from '../../../components/Spinner'
import { Text } from '../../../components/Text/Text'
import { useReferrals } from '../../../hooks/query/useReferrals'
import { referralStatusHuman } from '../../../models/referral'
import { User } from '../../../models/user'
import { darkGray, lightGray1 } from '../../../theme/colors'
interface ProfileReferralsProps {
  user: User
  canEdit: boolean
}

export function ProfileReferrals({ user, canEdit }: ProfileReferralsProps) {
  const { referrals, isLoading } = useReferrals(user.id)

  function renderContent() {
    if (isLoading || !referrals) {
      return <InlineSpinner mt={2} mb={2} />
    }

    if (!referrals?.referralCode) return null

    const referredBy = referrals.referredFrom?.referralCode.referrer

    return (
      <Grid columns="200px 1.5fr" gap="20px" mt={4}>
        <div>
          <FlexBox gap="20px" alignItems="center">
            <Text variant="header4" color={lightGray1}>
              Referrer
            </Text>
            {!referredBy && canEdit && (
              <Button
                variant="text"
                size="small"
                href={`/referrals/create?referree=${user.id}&return_user=${user.id}`}
                icon={<AddCircleIcon fontSize="small" />}
              >
                Add
              </Button>
            )}
          </FlexBox>
          {referredBy && (
            <FlexBox alignItems="flex-start" mt={1}>
              <Button variant="text" href={`/users/${referredBy.id}/show/`}>
                {referredBy.firstName} {referredBy.lastName}
              </Button>
            </FlexBox>
          )}
        </div>
        <div>
          <FlexBox alignItems="center" gap="10px" mt={-6.5} mb={3.3}>
            <Text variant="header3" color={darkGray}>
              Code {referrals?.referralCode.humanId}
            </Text>
            <CopyToClipBoardIcon text={referrals?.referralCode.humanId} />
          </FlexBox>
          <Grid
            columns={referrals.referrals?.length ? '170px 1fr' : 'auto 1fr'}
            gap="20px"
            alignItems="center"
            justifyItems="start"
          >
            <Text variant="header4" color={lightGray1}>
              Referrals
            </Text>
            {canEdit && (
              <Button
                variant="text"
                size="small"
                href={`/referrals/create?referrer=${referrals?.referralCode.id}&return_user=${user.id}`}
                icon={<AddCircleIcon fontSize="small" />}
                margin="0"
              >
                Add
              </Button>
            )}
          </Grid>
          {referrals.referrals?.map((ref) => (
            <Fragment key={ref.id}>
              <Divider mt={1} mb={1} />
              <Grid columns="170px 1fr" gap="20px" alignItems="center" justifyItems="start">
                <Button variant="text" href={`/users/${ref.referree.id}/show/`}>
                  {ref.referree.firstName} {ref.referree.lastName}
                </Button>
                <Text variant="label3" color={darkGray}>
                  {referralStatusHuman[ref.status]}
                </Text>
              </Grid>
            </Fragment>
          ))}
        </div>
      </Grid>
    )
  }

  return (
    <Card hasSubtleShadow smallPadding align="left">
      <Text variant="uppercaseLabel3">Referrals</Text>
      {renderContent()}
    </Card>
  )
}
